<div class="cm-color-input-container" [style.background-color]="$hexValue()">
    <input
        name="colorValue"
        class="cm-color-input"
        type="color"
        matInput
        [ngModel]="$hexValue()"
        (ngModelChange)="changeValue($event)"
        [ngModelOptions]="{standalone: true}"
        (focus)="onFocus()"
        (blur)="onBlur()"
    />
</div>
